import * as moment from 'moment';

export interface ICustomFieldQueryModel {
  id: string;
  itemId: string;
  name: string;
  value: string;
  featured: boolean;
  dateRangeAttributeStartDateValue?: Date;
  dateRangeAttributeEndDateValue?: Date;
}

export class ComplexFieldQueryModel {
  public flatValuesGroup: IComplexFieldFlatValueModel[][] = [];

  constructor(
    public id: string,
    public name: string,
    public values: IComplexFieldValueQueryModel[]
  ) {
    this.values = values.sort((a, b) => a.rank - b.rank);
    this.values.forEach((x) => {
      let date = moment(x.value, 'YYYY-MM-DD', true);
      if (date.isValid()) {
        x.value = moment(x.value).format('MM/DD/YYYY');
      }
    });

    this.flatValuesGroup = this.flatAndGroupValues(values);
  }

  private flatAndGroupValues(
    items: IComplexFieldValueQueryModel[]
  ): IComplexFieldFlatValueModel[][] {
    const groups: { [key: number]: IComplexFieldValueQueryModel[] } = {};

    // Group items by groupId
    items.forEach((item) => {
      if (!groups[item.groupId]) {
        groups[item.groupId] = [];
      }
      groups[item.groupId].push(item);
    });

    return Object.values<IComplexFieldValueQueryModel[]>(groups).map((array) => {
      return Object.values<IComplexFieldFlatValueModel>(
        array.reduce((acc, current) => {
          const key = `${current.id}-${current.rank}`;
          if (!acc[key]) {
            acc[key] = { rank: current.rank, value: [] };
          }
          //remove html tags for long answer
          acc[key].value.push(current.value.replace(/<[^>]+>/g, ''));
          return acc;
        }, {})
      ).sort((a, b) => a.rank - b.rank);
    });
  }
}

export interface IComplexFieldValueQueryModel {
  subFieldDefinitionItemId: string;
  uiType: string;
  groupId: number;
  id: string;
  itemId: string;
  name: string;
  value: string;
  dateRangeAttributeStartDateValue?: Date;
  dateRangeAttributeEndDateValue?: Date;

  rank: number;
}

export interface IComplexFieldFlatValueModel {
  value: string[];
  rank: number;
}
